module.exports = __webpack_public_path__ + "static/img/nfl-white1.1b943a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/svg/nfl-white1.svg
// module id = ze+x
// module chunks = 1